import { AxiosError } from 'axios';
import { GET_MIMS_STATUS_URL } from '../../constants/apiUrls';
import { GET_MIMS_STATUS_KEY } from '../../constants/queryKeys';
import axiosClient from '../../api-refactored/axiosClient';
import { useCustomQuery } from '../../api-refactored/utils/useCustomQuery';

// =============================================================================
// Query
// =============================================================================

export interface MIMSResponse {
  enable: boolean;
  mimsAltLoginMsg: String;
}

interface Input {
  onSuccess?: (data: MIMSResponse) => void;
  onError?: (error: AxiosError) => void;
}

export const useGetMIMSStatus = ({ onSuccess, onError }: Input) => {
  const getMIMSStatus = async () => {
    const res = await axiosClient.get<MIMSResponse>(GET_MIMS_STATUS_URL);

    return res.data;
  };

  return useCustomQuery(
    GET_MIMS_STATUS_KEY,
    getMIMSStatus,
    {
      onSuccess,
      onError,
      staleTime: Infinity,
    },
    false
  );
};
